<template>
  <div class="more">
    <div>
      <ul class="myUL" v-for="item in item" :key="item.id">
        <li @click="jump(item)">{{item.menuName}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import {api} from "../utils/api";

  export default {
    data() {
      return {
        item: []
      }
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    created() {
      this.init();
    },
    mounted() {
      this.init();
    },
    // 监听
    watch: {
      // 动态获取导入序号
      '$route': function (to, from) {
        // 可以拿到目标参数 to.query.id 去再次请求数据接口
        // 加载表格数据
        this.init()
      }

    },
    methods: {
      init() {
        document.title = this.$route.query.name;
        this.item = this.$route.query.item;
      },
      jump(item) {
        let href = this.$urlParamProcess(item);
        this.showLoading();
        this.$addAccessLog(item.menuId, 5, href, item.menuName).then(() => {
          this.hideLoading();
          window.location.href = href;
        });
      },
      showLoading() {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        });
      },
      hideLoading() {
        this.$toast.clear();
      }
    }
  }
</script>
<style scoped>
  .more {
    width: 100%;
    height: 100%;
    background-color: #F0F2F5;
    position: absolute;
    z-index: 99;
    top: 0;
  }

  .myUL {
    /* 移除默认的列表样式 */
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .myUL li {
    height: 50px;
    line-height: 140%;
    display: flex;
    align-items: center;
    margin-bottom: 1px;
    background-color: #fff;
    padding: 0 12px;
    text-decoration: none;
    font-size: 16px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/more.vue